export default {"src":"/_next/static/media/my-bookings.a529debb.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};